import { api } from ".."
import { IState } from "../../types";

// função para pesquisar os estados
const StatesService = async (search: string, page: number) => {

    const response = await api.get('states', {
        params: {
            search, page
        }
    });

    return response;

}
// função para pesquisar os estados

// função para cadastrar estado
const StatesCreateService = async (description: string, uf: string) => {

    const response = await api.post('states', {
        description, uf
    });

    return response;

}
// função para cadastrar estado

// função para atualizar um estado
const StateUpdateService = async (id: number, description: string, uf: string) => {

    const response = await api.put(`states/${id}`, {
        description, uf
    });

    return response;

}
// função para atualizar um estado

// função para desativar/ativar estado
const StatesDeleteService = async (id: number) => {

    const response = await api.delete(`states/${id}`);

    return response;

}
// função para desativar/ativar estado

// função para pesquisar todos os estados
const StatesAllService = async () => {

    const response = await api.get('states/all');

    return response;

}
// função para pesquisar todos os estados

export {
    StatesService,
    StatesCreateService,
    StateUpdateService,
    StatesDeleteService,
    StatesAllService
}